module.exports = __webpack_public_path__ + "media/assets/images/flags/af-0a726b767a04728f1001384278fb2f5c.svg";